import * as Sentry from '@sentry/react'

/**
 * Handle a Mapbox GL initialization failure — most commonly `Failed to initialize
 * WebGL`, thrown by `new mapboxgl.Map(...)` on browsers that cannot create a WebGL
 * context (hardware acceleration disabled, blocklisted driver, VM/remote desktop,
 * software rendering off).
 *
 * This is an *expected* environmental failure: the map components degrade to an
 * OpenStreetMap iframe (or a small placeholder for admin views), so it must NOT be
 * reported to Sentry as a captured exception — that would page us for every affected
 * visitor. We leave a debug breadcrumb only, useful when a *later* real error is
 * captured in the same session.
 */
export function reportMapWebglFallback(err: unknown): void {
  Sentry.addBreadcrumb({
    category: 'map',
    level: 'debug',
    message: 'Mapbox GL failed to initialize; falling back to OSM/placeholder',
    data: { error: err instanceof Error ? err.message : String(err) },
  })
}
